import { render, staticRenderFns } from "./trialLink.vue?vue&type=template&id=6f0c157f&scoped=true&"
import script from "./trialLink.vue?vue&type=script&lang=js&"
export * from "./trialLink.vue?vue&type=script&lang=js&"
import style0 from "./trialLink.vue?vue&type=style&index=0&id=6f0c157f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c157f",
  null
  
)

export default component.exports